import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FinancialCostSetting } from '../../_models/financials/financialCostSetting';
import { environment } from './../../../../environments/environment';

@Injectable()
export class FinancialCostSettingService {
  private financeServiceUrl = environment.financeServiceUrl;

  constructor(private http: HttpClient) {}

  getList(year: number): Observable<FinancialCostSetting[]> {
    return this.http.get<FinancialCostSetting[]>(
      `${this.financeServiceUrl}api/private/v1/finance/settings?cropYear=${year}`
    );
  }

  get(id: number): Observable<FinancialCostSetting> {
    return this.http.get<FinancialCostSetting>(
      `${this.financeServiceUrl}api/private/v1/finance/settings/${id}`
    );
  }

  save(financeCostSettingItem: FinancialCostSetting): Observable<FinancialCostSetting> {
    const financeCostSetting = { ...financeCostSettingItem };
    // Rimuovi campi non necessari
    delete financeCostSetting.lastUpdated;
    delete financeCostSetting.dateCreated;

    // Imposta il companyId se esiste
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    financeCostSetting.companyId = companySelected ? companySelected.id : null;

    // Se l'oggetto ha un id, esegui PUT, altrimenti POST
    if (financeCostSetting.id) {
      return this.http.put<FinancialCostSetting>(
        `${this.financeServiceUrl}api/private/v1/finance/settings/${financeCostSetting.id}`,
        financeCostSetting
      );
    } else {
      return this.http.post<FinancialCostSetting>(
        `${this.financeServiceUrl}api/private/v1/finance/settings/`,
        financeCostSetting
      );
    }
  }

  delete(financeCostSetting: FinancialCostSetting): Observable<FinancialCostSetting> {
    return this.http
      .delete<void>(
        `${this.financeServiceUrl}api/private/v1/finance/settings/${financeCostSetting.id}`
      )
      .pipe(
        map(() => {
          return { id: financeCostSetting.id } as FinancialCostSetting;
        })
      );
  }
}
